import API from "../../apiWrapper";
import { ReportOutput } from "../../../enums/ReportOutput";
import { IStateBoardReportParam } from "../../../interfaces/reports/stateboardReportParam";
import { IPennsylvaniaStateBoardReportProgramCode } from "../../../interfaces/setup/reports/IPennsylvaniaStateBoardReportProgramCode";
import { IMichiganStateBoardSettings } from "../../../interfaces/setup/reports/IMichiganStateBoardSettings";
import { IIndianaStateBoardReport } from "../../../interfaces/setup/reports/IIndianaStateBoardReportProgramCode";
import { NaccasSettingsPayload } from "../../../interfaces/setup/reports/INaccasSettingsPayload";


export const generateStateBoardReport = (
  params: IStateBoardReportParam,
  isPreview: boolean = false
) => {
  return API()
    .post(
      "/Reports/AcademicRecords/StateBoardReport/PrintStateBoardReport",
      params,
      {
        responseType: "blob",
      }
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          if (isPreview && ReportOutput.Pdf == params.exportType) {
            return res.data;
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            let exportType: number = Number(params.exportType);
            let extension = "";
            switch (exportType) {
              case Number(ReportOutput.Pdf):
                extension = "pdf";
                break;
              case Number(ReportOutput.Excel):
                extension = "xls";
                break;
              case Number(ReportOutput.Word):
                extension = "doc";
                break;
              case Number(ReportOutput.CSV):
                 extension = "csv";
               break;
              default:
                extension = "pdf";
                break;
            }
            const fileName =
              "StateBoardReport_" +
              new Date()
                .toISOString()
                .replace("T", " ")
                .replace(/\..*$/, "")
                .split(" ")[0]
                .split("-")
                .join("") +
              "." +
              extension;

            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          }
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const getPennsylvaniaStateBoardReportProgramCode = (reportId:string, campusId:string | null) => {
  return API()
    .get(
      `/Reports/AcademicRecords/StateBoardReport/GetPennsylvaniaStateBoardReportProgramCode?reportId=${reportId}&campusId=${campusId}`,
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const upsertPennsylvaniaStateBoardReportProgramCode = (reportId:string, settings:IPennsylvaniaStateBoardReportProgramCode[]) => {
  return API()
    .post(
      `/Reports/AcademicRecords/StateBoardReport/UpsertPennsylvaniaStateBoardReportProgramCode?reportId=${reportId}`,settings
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const getMichiganStateBoardReportProgramCode = (reportId:string, campusId:string, stateId:string) => {
  return API()
    .get(
      `StateBoardSettings/GetStateBoardReportSetting?CampusId=${campusId}&ReportId=${reportId}&StateId=${stateId}`,
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const saveMichiganStateBoardReportSettings = (settings:IMichiganStateBoardSettings) => {
  return API()
    .post(
      `StateBoardSettings/SaveOrUpdateMichiganStateBoardReportSetting`,settings
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const deleteMichiganStateBoardReportSettings = (campusId:string, reportId:string, stateId:string) => {
  return API()
    .delete(
      `StateBoardSettings/DeleteStateBoardReportSetting?`,{
        data:{
          CampusId:campusId,
          ReportId:reportId,
          StateId:stateId
        }
      }
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const getStateBoardAgencyDetail = (agencyId:number) => {
  return API()
    .get(
      `SystemCatalog/StateBoardAgency/GetStateBoardAgency?agencyId=${agencyId}`,
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const getIndianaStateBoardReportSettings = (reportId:string, stateId:string, campusId:string | null) => {
  return API()
    .get(
      `StateBoardSettings/GetIndianaStateBoardReportSetting?CampusId=${campusId}&ReportId=${reportId}&StateId=${stateId}`,
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const upsertIndianaStateBoardReportProgramCode = (settings:IIndianaStateBoardReport) => {
  return API()
    .post(
      `/StateBoardSettings/SaveOrUpdateIndianaStateBoardReportSetting`,settings
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const deleteIndianaStateBoardReportSettings = (campusId:string, reportId:string, stateId:string) => {
  return API()
    .delete(
      `StateBoardSettings/DeleteIndianaStateBoardReportSetting?`,{
        data:{
          CampusId:campusId,
          ReportId:reportId,
          StateId:stateId
        }
      }
    )
    .then(
      (res: any) => {
        if (res && res.data) {
          return res.data;
        }
      },
      (error: any) => {
        return null;
      }
    );
};

export const getNaccasReportSetting = (campusId: string) => {
  return API()
    .get(`/NaccasSettings/GetNaccasReportSetting?campusId=${campusId}`)
    .then(res => res.data);
};

export const SaveOrUpdateNaccasReportSetting = (payload: NaccasSettingsPayload) => {
  return API()
    .post(`/NaccasSettings/SaveOrUpdateNaccasReportSetting`, payload)
    .then(res => res.data);
};

export const getNaccasDropReasons = () => {
  return API()
    .get(`/SystemCatalog/DropReason/GetNaccasDropReasons`)
    .then(res => res.data);
};